// import {http} from '../../axios'
import Vue from 'vue'
import {typesList} from '../../constants/characteristicsScheduleTypesList'

const mutationsSubscribeNames = [
  'setInputValue',
  'setShiftValue',
  'setSelectedDaysValue',
]


function createDaysQuantity() {
  let a = []
  for (let i = 1; i < 11; i++) {
    a.push(i)
  }
  return a
}

function getInitState() {
  return {
    muted: false,
    pendingLoad: false,
    inputs: {
      type: {
        value: null
      },
      minimum_hours: {
        value: 1
      },
      working_days: {
        value: 1
      },
      weekend_interval: {
        value: 1
      },
      weekly: {
        value: false
      },
      comment: {
        value: null
      }
    },
    shifts: []
  }
}

export default {
  namespaced: true,
  state: {
    ...getInitState(),
    mutationsSubscribeNames,
    typesList,
    daysQuantity: createDaysQuantity(),
    minHoursQuantity: createDaysQuantity(),
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setInputValue(state, {key, value}) {
      if (!state.inputs.hasOwnProperty(key)) return
      state.inputs[key].value = value
    },
    setShiftsAll(state, shifts) {
      state.shifts = shifts
    },
    setShiftValue(state, {index, key, value}) {
      if (!state.shifts[index]) return
      Vue.set(state.shifts[index], key, value)
    },
    setSelectedDaysValue(state, {index, value}) {
      if (!state.shifts[index]) return
      Vue.set(state.shifts[index], 'selected_days', value)
    }
  },
  actions: {
    setValueFromLists({state, commit}) {
      const keys = {
        'type': 'typesList'
      }

      for (let [key, listKey] of Object.entries(keys)) {
        if (!state.inputs[key].value) {
          let value = state[listKey][0]
          if(value) commit('setInputValue', {key, value})
        } else if (!isNaN(state.inputs[key].value)) {
          let value = state[listKey].find(item => item.id === state.inputs[key].value)
          if(value) commit('setInputValue', {key, value})
        }
      }

      commit('setMuted', false)
    },
    setVacancyValues({state, commit, dispatch}, vacancy) {
      if (!vacancy.schedule) return
      for (let key in state.inputs) {
        commit('setInputValue', {key, value: vacancy.schedule[key]})
      }

      if(vacancy.schedule.shifts && vacancy.schedule.shifts.length) {
        commit('setShiftsAll', vacancy.schedule.shifts)
      }

      if(typeof vacancy.schedule.weekly !== 'boolean') {
        commit('setInputValue', {key: 'weekly', value: false})
      }

      dispatch('setValueFromLists')
    }
  }
}
